module.exports = __webpack_public_path__ + "static/media/telethon-kids-2020@2x.4cf6d4db.png";